export default function (editor, opts = {}) {
  const options = opts;
  const bm = editor.BlockManager;
  const pfx = options.pfx;

  if (options.blocks.indexOf('socket-alert') >= 0) {
    bm.add('socket-alert', {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="70" fill="#010101"><path d="M63.988 31.295c-.174-10.7-6.14-21.118-15.37-26.604C41.346.162 32.16-1.057 23.886 1.033 11.433 4.168 1.505 15.446.243 28.3-1.325 40.44 4.815 53.066 15.308 59.292c10.276 6.444 24.253 6.183 34.3-.6 9.057-5.878 14.674-16.6 14.37-27.388zM33.77 59.25c-14.543 1.437-28.607-10.885-29-25.472-1.1-11.843 6.705-23.556 17.852-27.475C38.254.033 57.456 11.615 59.067 28.38c2.526 15.064-10.014 30.4-25.297 30.87zM24.2 30.38l21.03-17.2-11.364 17.243c-3.222 0-6.444 0-9.666-.044zm5.913 3.18l9.666.044-21.03 17.243L30.113 33.56z"/></svg>
      <div class="gjs-block-label">${options.labelTable}</div>
      `,
      category: options.labelSocketAlertCategory,
      content: `
                <div
                  data-gjs-type="socket-alert"
                  data-socket-alert-component
                  data-gjs-custom-name="${options.labelTable}"
                  class="alert alert-primary m-0 p-2 text-decoration-none text-dark ${pfx}"
                  role="alert"
                  style="cursor: pointer;"
                >
                  <p class="mb-0">New data added — Click to view</p>
                </div>
              `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
          ${model.get('label')}
        </div>
      `,
    });
  }
}
